export default __webpack_public_path__ + "static/media/user.86bef5e5.svg";